import React, {Component} from "react";
import {connect} from 'react-redux';
import {MdNavigateBefore} from 'react-icons/md';
import {
    Grid,
    Row,
    Col,
    OverlayTrigger,
    Popover, Tooltip,
} from "react-bootstrap";
import {Card} from "components/Card/Card.jsx";
import Select from 'react-select';
import ToggleButton from "react-toggle-button";
import {themeCSSConstants} from 'redux/constant/themeCSS';
import {helperFunctions as HF} from 'helper/helperFunctions';
import {withRouter} from 'react-router-dom';
import {SortableContainer, SortableElement, SortableHandle, arrayMove} from 'react-sortable-hoc';
import {brandActions} from "redux/actions/brand-actions";
import tagIcon from "assets/img/price_tag.png";
import cardIcon from "assets/img/card_machine.png";
import composeIcon from "assets/img/text_compose.png";
import isEqual from 'lodash.isequal';

var cloneDeep = require('lodash.clonedeep');

const DragHandle = SortableHandle(() => <OverlayTrigger placement="bottom"
                                                        overlay={<Popover id="tooltip">Click and Hold to
                                                            Drag</Popover>}><span
    className="moveIcon orderDetailsAction"></span></OverlayTrigger>);
const SortableItem = SortableElement(({value, deleteItem, view_mode, onCheckFlag}) => (

    <tr key={`innerItem-${value.key}`}>

        <td><span className="linkColor">Step {value.key + 1}</span></td>
        <td>{value.value['title']}</td>

        <td>
            {
                value.value['attribute_title'] != "required layout option" &&
                <span className={view_mode ? 'disabledToggle' : ''}>
                    <ToggleButton
                        inactiveLabel={''}
                        activeLabel={''}
                        colors={themeCSSConstants.THUMBICONSTYLE}
                        trackStyle={themeCSSConstants.TRACKSTYLE}
                        thumbStyle={themeCSSConstants.THUMBSTYLE}
                        thumbAnimateRange={[4, 30]}
                        value={value.value['is_multiselect']}
                        onToggle={(e) => onCheckFlag(e, value.key, 'is_multiselect')}
                        name="is_multiselect"
                    />
               </span>
            }
        </td>

        <td>
            <DragHandle/>
            <OverlayTrigger placement="bottom" overlay={<Popover id="tooltip">Delete Row</Popover>}>
				<span>
					<button
                        onClick={() => {
                            deleteItem(value.key, value.value['attribute_title'])
                        }} className="deleteIcon orderDetailsAction"
                        disabled={view_mode}
                    >&nbsp;</button>
				</span>
            </OverlayTrigger>
        </td>
    </tr>
));

const SortableList = SortableContainer(({attributes, deleteItem, view_mode, onCheckFlag}) => {
    return (
        <tbody>
        {
            attributes.map((value, index) => (

                <SortableItem
                    key={`item-${index}`}
                    index={index}
                    value={{value: value, key: index}}
                    test={`item-${index}`}
                    deleteItem={deleteItem}
                    view_mode={view_mode}
                    disabled={view_mode}
                    onCheckFlag={onCheckFlag}
                />

            ))
        }

        </tbody>
    );
});

class BrandOrderWorkflowPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            workFlow: {
                tag_layout: false,
                tag_layout_index: null,
                brand: '',
                brand_Id: null,
                brand_data_def_id: null,
                number_of_tags: 0,
                // looping to set attribute title to 'required layout option' because its null by default at backend
                attributes: this.props.fetchedOrderWorkflow ? this.props.fetchedOrderWorkflow.order_steps ? this.props.fetchedOrderWorkflow.order_steps.map((element) => {
                        if (element.attribute_title === null) {
                            return {
                                ...element,
                                attribute_title: 'required layout option',
                                title: 'Required Layout Option'
                            };
                        } else {
                            return element;
                        }
                    })
                    : []
                    : [],
                vendor_attr_db_col: ''

            },
            isChanged: false,
            // Appending count and disbale properties to handle enabling and disabling in dropdown
            product_attributes: HF.appendValues(
                HF.appendCount(
                    this.props.fetchedOrderWorkflow ? this.props.fetchedOrderWorkflow.product_attributes ? this.props.fetchedOrderWorkflow.product_attributes : [] : []
                    , 'count'
                ),
                [
                    {column: 'disable', value: false}
                ]
            ),
            // for taglayout and vendor dropdown
            active_product_attributes: this.props.fetchedOrderWorkflow ? this.props.fetchedOrderWorkflow.product_attributes ? this.props.fetchedOrderWorkflow.product_attributes : [] : []
        }
    }

    changeFlag = (toggle) => {
        const workFlowState = cloneDeep(this.state.workFlow);
        workFlowState['tag_layout_index'] = null;
        workFlowState['tag_layout'] = !toggle;
        this.setState({workFlow: workFlowState})
    }

    onCheckFlag = (toggle, rowIndex, name) => {
        const atts = cloneDeep(this.state.workFlow.attributes);
        atts[rowIndex][name] = !toggle;
        console.log('attsattsattsatts', atts)
        this.setState({
            workFlow: {
                ...this.state.workFlow,
                attributes: atts
            }
        });
    }

    onSortEnd = ({oldIndex, newIndex}) => {
        const workFlowState = cloneDeep(this.state.workFlow);
        workFlowState['attributes'] = arrayMove(this.state.workFlow.attributes, oldIndex, newIndex)
        this.setState({workFlow: workFlowState}, () => {
            this.state.workFlow.attributes.forEach((data, index) => {
                if (data.attribute_title === 'required layout option') {
                    this.setState({
                        workFlow: {
                            ...this.state.workFlow,
                            tag_layout_index: index + 1,
                        }
                    })
                }
            })
        });
    };

    handleChangeItem = (selectedOptionType, info) => {
        if (info['action'] === 'select-option') {
            const workFlowState = cloneDeep(this.state.workFlow);
            workFlowState['attributes'].push({
                attribute_title: selectedOptionType['db_column'],
                title: selectedOptionType['title']
            });
            this.setState({workFlow: workFlowState}, function () {
                const product_attributesState = cloneDeep(this.state.product_attributes);
                product_attributesState[selectedOptionType['count']]['disable'] = true;
                this.setState({product_attributes: product_attributesState})
            })
        }
    }

    hanldeAttributeChange = (selectedOptionType, info) => {
        if (info['action'] === 'select-option') {
            this.setState({
                workFlow: {
                    ...this.state.workFlow,
                    [info.name]: {
                        title: selectedOptionType['title'],
                        db_column: selectedOptionType['db_column']
                    }
                }
            })
        } else {
            this.setState({
                workFlow: {
                    ...this.state.workFlow,
                    [info.name]: ''
                }
            })
        }
    }

    deleteItem = (key, item_id) => {
        if (item_id === 'required layout option') {
            this.setState({
                workFlow: {
                    ...this.state.workFlow,
                    tag_layout: false
                }
            })
            return
        }
        const attributesState = cloneDeep(this.state.workFlow);
        attributesState['attributes'].splice(key, 1);
        this.setState({workFlow: attributesState}, () => {
            if (item_id) {
                var indexItem = HF.returnKeyWithColumnMatch('db_column', this.state.product_attributes, item_id);
                if (this.state.product_attributes + 1 > indexItem) {
                    const product_attributesState = cloneDeep(this.state.product_attributes);
                    product_attributesState[indexItem]['disable'] = false;
                    this.setState({product_attributes: product_attributesState})
                }
            }
        });
    }
    onSubmit = () => {
        let layoutIndex = null;
        let layoutFlag = false;
        const newAttributes = this.state.workFlow.attributes.map((data, index) => {
            if (data.attribute_title === 'required layout option') {
                layoutIndex = index + 1;
                layoutFlag = true;
            }
            return {attribute_title: data.attribute_title, is_multiselect: data.is_multiselect || false}
        })
        let obj;
        obj = {
            attributes_type: 'order_steps',
            tag_layout: layoutFlag,
            tag_layout_index: layoutIndex,
            brand_attributes: [...newAttributes],
            vendor_attr_db_col: this.state.workFlow.vendor_attr_db_col.db_column || '',
            _method: 'put'
        }
        this.setState({
            isChanged: true,
        })
        if (this.props.fetchedOrderWorkflow) {
            this.props.storeBrandDataDefinitionCall(obj, this.props.storedBrand.id).then(res => {
                this.props.history.push({
                    pathname: `/Admin/brand/${this.props.storedBrand.id}/transformation-rules`, state: {
                        product_attributes: res.result.data_definition.product_attributes,
                        brand_id: res.result.data_definition.brand_id,
                        definition_id: res.result.data_definition.id,
                        delimiter: res.result.data_definition.delimiter,
                        response: res.result.data_definition,
                    }
                })
            })
            return;
        }
        this.props.storeBrandDataDefinitionCall(obj, this.props.storedBrand.id).then(res => {
            this.props.history.push({
                pathname: `/Admin/brand/${this.props.storedBrand.id}/transformation-rules`, state: {
                    product_attributes: res.result.data_definition.product_attributes,
                    brand_id: res.result.data_definition.brand_id,
                    definition_id: res.result.data_definition.id,
                    delimiter: res.result.data_definition.delimiter,
                    response: res.result.data_definition,
                }
            })
        })
    }

    findAttributeWithFlag = (flag, arr = []) => {
        let temp = '';
        arr.forEach(item => {
            if (item[flag]) {
                temp = {
                    title: item.title,
                    db_column: item.db_column
                }
            }
        })
        return temp;
    }

    componentDidUpdate(prevProps, prevState) {

        if (!isEqual(this.state.workFlow.attributes, prevState.workFlow.attributes)) {
            this.setState({
                isChanged: true,
            })
        }

        if (this.props.productAttributes.length !== prevProps.productAttributes.length) {
            this.setState({
                    product_attributes: HF.appendValues(
                        HF.appendCount(
                            [...this.props.productAttributes]
                            , 'count'
                        ),
                        [
                            {column: 'disable', value: false}
                        ]
                    ),
                    active_product_attributes: this.props.productAttributes
                },
            )
        }

        if (this.props.productAttributes !== prevProps.productAttributes && this.props.fetchedOrderWorkflow) {
            const titles = this.props.fetchedOrderWorkflow.order_steps.map(element => {
                return element.attribute_title
            })
            const newArray = [];
            this.props.productAttributes.forEach((data) => {
                if (titles.includes(data.db_column)) {
                    newArray.push({
                        ...data,
                        disable: true
                    })
                } else {
                    newArray.push({
                        ...data,
                        disable: false
                    })
                }
            })
            this.setState({
                    product_attributes: HF.appendCount(
                        [...newArray]
                        , 'count'
                    ),
                    active_product_attributes: this.props.productAttributes
                },
            )
            const attribute_titles = this.props.productAttributes.map(element => {
                return element.db_column
            })
            const latest = [];
            this.state.workFlow.attributes.forEach(data => {
                if (attribute_titles.includes(data.attribute_title)) {
                    latest.push(data)
                }
                if (data.attribute_title === 'required layout option') {
                    latest.push(data)
                }
            });
            this.setState({
                workFlow: {
                    ...this.state.workFlow,
                    attributes: [...latest].map(item => {
                        return item
                    }),
                    vendor_attr_db_col: this.findAttributeWithFlag('is_external_vendor_attr', this.props.productAttributes)
                }
            })
        }

        if (prevState.workFlow.tag_layout !== this.state.workFlow.tag_layout) {

            if (this.state.workFlow.tag_layout) {
                const titles = this.state.workFlow.attributes.map(element => {
                    return element.attribute_title
                })
                if (titles.includes('required layout option')) {
                    return;
                }
                const addTagLayoutState = cloneDeep(this.state.workFlow);
                addTagLayoutState['tag_layout_index'] = this.state.workFlow.attributes.length + 1;
                addTagLayoutState['attributes'].push({
                    attribute_title: 'required layout option',
                    attr_id: this.state.product_attributes.length + 1,
                    title: 'Required Layout Option'
                });
                this.setState({workFlow: addTagLayoutState})
            } else if (!this.state.tag_layout) {
                let key = HF.returnKeyWithColumnMatch('attribute_title', this.state.workFlow.attributes, 'required layout option');
                if (key) {
                    const attributesState = cloneDeep(this.state.workFlow);
                    attributesState['attributes'].splice(key, 1);
                    this.setState({workFlow: attributesState});
                }
            }
        }
    }

    componentDidMount() {
        if (this.props.fetchedOrderWorkflow) {
           
            const titles = this.state.workFlow.attributes.map(element => {
                return element.attribute_title
            })
            const newArray = [];

            this.state.product_attributes.forEach((data) => {
                if (titles.includes(data.db_column)) {
                    newArray.push({
                        ...data,
                        disable: true
                    })
                } else {
                    newArray.push({
                            ...data,
                            disable: false
                        }
                    )
                }
            })
            this.setState({
                product_attributes: HF.appendCount(
                    [...newArray]
                    , 'count'
                ),
                workFlow: {
                    ...this.state.workFlow,
                    vendor_attr_db_col: this.findAttributeWithFlag('is_external_vendor_attr', this.state.product_attributes)
                }
            }, () => {
                this.props.fetchedOrderWorkflow.order_steps.forEach((element, index) => {
                    if (element.attribute_title === null) {
                        this.setState({
                            workFlow: {
                                ...this.state.workFlow,
                                tag_layout: true,
                                tag_layout_index: index + 1,
                            }
                        })
                    }
                })
    
            });

        }
    }

    render() {
        const {workFlow, product_attributes} = this.state;
        const {view_mode} = this.props;
        return (
            <div>
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <Card
                                ctTableResponsive
                                content={
                                    <div id="brandDataTable">
                                        <Grid fluid>
                                            <Row>
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className='form-group'>
                                                            <div className="clearfix">
                                                                <div className="ol-md-12">
                                                                    <h3 style={{
                                                                        textAlign: 'center',
                                                                        fontWeight: "500"
                                                                    }}>Manage Order Workflow</h3>
                                                                </div>

                                                                <div className="col-md-12">
                                                                    <p className="mt-lg">
                                                                        Using this form, you will be able to define
                                                                        order workflow for this specific brand. Here is
                                                                        a quick guide.
                                                                    </p>
                                                                    <p>
                                                                        Use the add step button to create a new step or
                                                                        pre-requisite for showing the order data. Here
                                                                        are some examples of pre-requisites.
                                                                    </p>
                                                                </div>

                                                                <div className="col-md-12">
                                                                    <div className="manageOrderGrid">
                                                                        <div>
                                                                            <img src={tagIcon} alt=""/>
                                                                            <p>
                                                                                This brand requires selection of a Tag
                                                                                layout to place an order.
                                                                            </p>
                                                                            <div className="step_number">
                                                                                <span>1</span>
                                                                            </div>
                                                                        </div>
                                                                        <div>
                                                                            <img src={cardIcon} alt=""/>
                                                                            <p>
                                                                                This brand requires selection of a PO to
                                                                                place an order.
                                                                            </p>
                                                                            <div className="step_number">
                                                                                <span>2</span>
                                                                            </div>
                                                                        </div>
                                                                        <div>
                                                                            <img src={composeIcon} alt=""/>
                                                                            <p>
                                                                                This brand requires selection of a Style
                                                                                to place an order.
                                                                            </p>
                                                                            <div className="step_number">
                                                                                <span>3</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <p className="mt-xlg">
                                                                        You can add, remove or re-order the steps to
                                                                        create a workflow that best suits the brand. All
                                                                        fields defined under data definition for the
                                                                        brand are available to be selected as a
                                                                        prerequisite.
                                                                    </p>
                                                                </div>

                                                                <div className="col-md-8 col-md-offset-2 mt-md">
                                                                    <div
                                                                        className="flexElem fieldWithLabel alignFlexCenter">
                                                                        <div className="mt-md"
                                                                             style={{flexBasis: "35%"}}>
                                                                            <label htmlFor="name">External Vendor Filter
                                                                                Attribute</label>
                                                                        </div>
                                                                        <div className="mt-md text-capitalize"
                                                                             style={{flexBasis: "65%"}}>
                                                                            <Select
                                                                                onChange={this.hanldeAttributeChange}
                                                                                name={'vendor_attr_db_col'}
                                                                                value={this.state.workFlow.vendor_attr_db_col}
                                                                                options={this.state.active_product_attributes}
                                                                                getOptionLabel={(option) => option.title}
                                                                                getOptionValue={(option) => option.db_column}
                                                                                isSearchable={true}
                                                                                isMulti={false}
                                                                                isClearable={true}
                                                                                placeholder={'Select Attribute for External Vendor Filter Attribute'}
                                                                                isOptionDisabled={(option) => option.disable === true}
                                                                                isDisabled={view_mode}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-8 col-md-offset-2 mt-md">
                                                                    <div
                                                                        className="flexElem fieldWithLabel alignFlexCenter">
                                                                        <div className="mt-lg"
                                                                             style={{flexBasis: "35%"}}>
                                                                            <label htmlFor="name">Required Tag Layout
                                                                                Selection </label>
                                                                        </div>
                                                                        <div className="mt-lg"
                                                                             style={{flexBasis: "65%"}}>
																			<span
                                                                                className={view_mode ? 'disabledToggle' : ''}>
																				<ToggleButton
                                                                                    inactiveLabel={''}
                                                                                    activeLabel={''}
                                                                                    colors={themeCSSConstants.THUMBICONSTYLE}
                                                                                    trackStyle={themeCSSConstants.TRACKSTYLE}
                                                                                    thumbStyle={themeCSSConstants.THUMBSTYLE}
                                                                                    thumbAnimateRange={[4, 30]}
                                                                                    value={workFlow.tag_layout}
                                                                                    onToggle={() => this.changeFlag(workFlow.tag_layout)}
                                                                                    name="tag_layout"
                                                                                />
																			</span>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-8 col-md-offset-2 mt-lg">
                                                                    <p className="mb-none">
                                                                        AND/OR
                                                                    </p>
                                                                </div>

                                                                <div className="col-md-8 col-md-offset-2">
                                                                    <div
                                                                        className="flexElem fieldWithLabel alignFlexCenter">
                                                                        <div className="mt-md"
                                                                             style={{flexBasis: "35%"}}>
                                                                            <label htmlFor="name">Filters on Product
                                                                                Listing</label>
                                                                        </div>
                                                                        <div className="mt-md text-capitalize"
                                                                             style={{flexBasis: "65%"}}>
                                                                            <Select
                                                                                onChange={this.handleChangeItem}
                                                                                options={product_attributes}
                                                                                getOptionLabel={(option) => option.title}
                                                                                getOptionValue={(option) => option.db_column}
                                                                                isSearchable={true}
                                                                                isMulti={false}
                                                                                placeholder={'Select Filters to show on Product Listing'}
                                                                                isOptionDisabled={(option) => option.disable === true}
                                                                                isDisabled={view_mode}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6 col-md-offset-3">
                                                                    <table
                                                                        className="table theme_table steps_table blank mt-xlg">
                                                                        <thead>
                                                                        <tr>
                                                                            <th>Order</th>
                                                                            <th>Filter</th>
                                                                            <th>Multi-Select</th>
                                                                            <th>Control</th>
                                                                        </tr>
                                                                        </thead>
                                                                        {
                                                                            <SortableList
                                                                                axis='y'
                                                                                attributes={workFlow.attributes}
                                                                                onSortEnd={this.onSortEnd}
                                                                                deleteItem={this.deleteItem}
                                                                                useDragHandle
                                                                                view_mode={view_mode}
                                                                                onCheckFlag={this.onCheckFlag}
                                                                            />
                                                                        }
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Row>
                                        </Grid>

                                        {
                                            !view_mode &&
                                            workFlow.attributes.length > 0 &&
                                            <div className="text-center">
                                                <button className="customBtn btnBlue m-md" onClick={this.onSubmit}>Save
                                                    Updates
                                                </button>
                                            </div>
                                        }
                                    </div>
                                }/>
                            <div className="stepsNav">
                                <div className="text-center">
                                    <button onClick={this.props.previousStep} className="stepNav prev">
                                        <MdNavigateBefore/></button>
                                    <span className="display_ib mt-xs">Prev</span>
                                </div>
                            </div>
                            {
                                view_mode &&
                                <div className="text-center">
                                    <button
                                        className="customBtn btnBlue m-md"
                                        type='button'
                                        onClick={() => {
                                            this.props.history.goBack()
                                        }}
                                    >Go Back
                                    </button>
                                </div>
                            }
                        </Col>
                    </Row>
                </Grid>
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return ({
        storeBrandCall: (brandData) => {
            return dispatch(brandActions.storeBrand(brandData))
        },
        storeBrandProductAttsCall: (brandData, id) => {
            return dispatch(brandActions.storeBrandProductAtts(brandData, id))
        },
        storeBrandOrderAttsCall: (brandData, id) => {
            return dispatch(brandActions.storeBrandOrderAtts(brandData, id))
        },
        storeBrandDataDefinitionCall: (data, id) => {
            return dispatch(brandActions.storeBrandDataDefinition(data, id))
        },
    });
};

function mapStateToProps(state) {
    const {brand} = state.brandReducer;
    return {
        brand,
    };
}


const BrandOrderWorkflow = withRouter(connect(mapStateToProps, mapDispatchToProps)(BrandOrderWorkflowPage));
export default BrandOrderWorkflow;



// WEBPACK FOOTER //
// ./src/components/Admin/Brands/BrandOrderWorkflow.jsx